import React from 'react';
import Type from 'prop-types';
import { noop } from 'lodash';
import { Drawer } from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';
import { useTranslation } from 'hooks';
import styles from './BottomSheet.module.css';

const BottomSheet = (props) => {
  const {
    open,
    onClick,
    onClose,
    fullScreen,
    showCloseButton,
    children,
    ...other
  } = props;
  const { t } = useTranslation();

  const renderCloseButton = () => {
    return (
      <div
        color="inherit"
        aria-label={t('close')}
        className={styles.closeButton}
        onClick={onClose}
      >
        <CloseIcon />
      </div>
    );
  };

  return (
    <Drawer
      anchor="bottom"
      open={open}
      onClick={onClick}
      onClose={onClose}
      sx={{ zIndex: 1300, background: '#f5f5f5' }}
      hideBackdrop
      classes={{
        paperAnchorBottom: fullScreen ? styles.fullScreen : null,
      }}
      {...other}
    >
      {showCloseButton && renderCloseButton()}
      {children}
    </Drawer>
  );
};

BottomSheet.propTypes = {
  open: Type.bool.isRequired,
  onClose: Type.func.isRequired,
  onClick: Type.func,
  children: Type.node.isRequired,
  fullScreen: Type.bool,
  showCloseButton: Type.bool,
};

BottomSheet.defaultProps = {
  onClick: noop,
  fullScreen: false,
  showCloseButton: false,
};

export default BottomSheet;
